<template>
  <div class="tempContainer">
    <div class="templateTop">
      <span class="tips">选择以下模板，快速体验网校（三选一）</span>
    </div>
    <div class="chooseTempBox">
      <div class="tempItem" v-for="(item, index) in tempOptions" :key="index">
        <p>{{ item.name }}</p>
        <img v-if="item.url" :src="item.url" alt="" />
        <div v-else class="empty-pic">暂无封面</div>
        <el-button type="primary" v-if="schoolMenuId == item.id"
          >使用中</el-button
        >
        <el-button
          @click="updateAgentTemp(item.id)"
          v-else
          v-auth="'onlineSchool_/schoolPageTemplate/updateAgentTemp'"
          >使用</el-button
        >
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      style="margin-top: 20px; text-align: right"
      :total="page.total"
      :page-size="page.pageSize"
      :current-page="page.pageNumber"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    schoolMenuId: String,
  },
  data() {
    return {
      page: {
        total: 0,
        pageSize: 3,
        pageNumber: 1,
      },
      tempOptions: [],
    };
  },
  methods: {
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getSchoolPageTemplatePageList();
    },
    // 获取模板列表
    getSchoolPageTemplatePageList() {
      this.api.schoolPageTemplate
        .pageList({
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
        })
        .then((res) => {
          this.tempOptions = res.data.records;
          this.page.total = res.data.total;
        });
    },

    // 选择模板
    updateAgentTemp(id) {
      this.api.schoolPageTemplate.updateAgentTemp({ id: id }).then((res) => {
        if (res.success) {
          this.$emit("changeschoolMenuId", id);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getSchoolPageTemplatePageList();
  },
};
</script>
<style scoped>
.empty-pic {
  font-size: 32px;
  color: #b0b0b0;
  text-align: center;
  line-height: 300px;
  width: 300px;
  height: 300px;
  border: 1px #b0b0b0 dashed;
  border-radius: 4px;
}
</style>
<style lang="less" scoped>
.templateTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.tempContainer {
  padding-bottom: 60px;
}
.chooseTempBox {
  display: flex;
  flex-direction: row;
  padding: 0 127px;
  justify-content: space-around;
  .tempItem {
    display: flex;
    flex-direction: column;
    align-content: center;
    p {
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      margin-bottom: 10px;
    }
    img {
      width: 300px;
      height: 300px;
    }
    .el-button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/mubanSetting.vue